// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"selectedTransaction_PageHeader__2yR4_"};